import { Injectable } from '@angular/core';
import { ObservableArray } from '@studiohyperdrive/rxjs-utils';
import { merge } from '@studiohyperdrive/utils';
import { map } from 'rxjs';

import { VlaioHttpClientService } from '@vlaio/shared/core';
import { ELoketEndpoints } from '@vlaio/shared/endpoints';
import { VlaioResult } from '@vlaio/shared/types';

import { VlaioZipCodeEntity, VlaioZipCodeResultEntity } from '../../interfaces';

@Injectable()
export class ZipCodeApiService {
	constructor(private readonly httpClient: VlaioHttpClientService) {}

	/**
	 * Get the zip codes for a given search string
	 *
	 * @param zoek - The provided search string
	 */
	public getZipCodes(zoek: string): ObservableArray<VlaioZipCodeEntity> {
		return this.httpClient
			.get<
				VlaioResult<VlaioZipCodeResultEntity, 'PostcodeVerzameling'>
			>(ELoketEndpoints.Company.ZipCodes(), { zoek }, true)
			.pipe(
				map(({ elementen }) => {
					return elementen.map((item) => {
						return merge<any>(
							{
								label: item.label,
								fusion: item.is_fusiegemeente,
								id: item.label
									.split(' ')
									.join('')
									.concat('' + (item?.niscode || item?.postcode))
							},
							['nis', item.niscode],
							['zip', item.postcode]
						);
					});
				})
			);
	}
}
